import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { isGoneUrl, resolveLegacyRedirect } from "@/lib/legacy-redirects";

/**
 * Catch-all : applique les redirections 301 des anciennes URLs WordPress,
 * renvoie 410 Gone sur les URLs de spam héritées, puis retombe sur la 404.
 */
export const Route = createFileRoute("/$")({
  server: {
    handlers: {
      GET: async ({ request, next }) => {
        const { pathname } = new URL(request.url);
        if (isGoneUrl(pathname)) {
          return new Response("410 Gone", {
            status: 410,
            headers: { "Content-Type": "text/plain; charset=utf-8" },
          });
        }
        return next();
      },
    },
  },
  beforeLoad: ({ location }) => {
    const target = resolveLegacyRedirect(location.pathname);
    if (target) {
      throw redirect({ href: target, statusCode: 301, reloadDocument: true });
    }
    throw notFound();
  },
  component: () => null,
});
